import { render } from "./GroupSelector.vue?vue&type=template&id=773320a2&scoped=true"
import script from "./GroupSelector.vue?vue&type=script&lang=js"
export * from "./GroupSelector.vue?vue&type=script&lang=js"

import "./GroupSelector.vue?vue&type=style&index=0&id=773320a2&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773320a2"]])

export default __exports__